<template>
  <v-app>
    <slot name="snackbar-content"/>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: 'LandingLayout',
  };
</script>